

import React, { useState, useEffect } from "react";
import { MenuLateral } from "../../../../Components/MenuLateral/Index";
import { Panel } from "../../../../Components/Panel";
import { Header } from "../../../../Components/Header";
import { PerfilInput } from "../../../../Components/PerfilInput";
import { useCartorio } from "../../../../Hooks/cartorio";
import { Alert } from "../../../../Components/Error/Alert";
import {
  Container,
  Formulario,
  HelperInput,
  HandleButton,
  HandleOperationButtons,
  HandleEditarButton,
} from "./styles";
import { DarkButton } from "../../../../Components/DarkButton";
import { validateEmail } from "../../../../Services/validaEmail";
import { validateCPF } from "../../../../Services/validateCPF";
import { limpa_cpf_cnpj } from "../../../../Services/limpa_cpf_cnpj";
import { validateCNPJ } from "../../../../Services/validateCPNJ";
import { limpaMaskCelular } from "../../../../Services/limpaMaskCelular";
import { validaCelular } from "../../../../Services/validaCelular";
import api from "../../../../Services/api";
import { ModalLoader } from "../../../../Components/ModalLoader";
import { EditarSenhaModal } from "../../../../Components/EditarSenhaModal";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";

export function PrefeituraPerfil() {
  const { prefeitura, checarTokenPrefeitura } = usePrefeitura();
  const [NOME, setNome] = useState("");
 
  const [loading, setloading] = useState(false);
  const [editarSenhaModal, setEditarSenhaModal] = useState(false);
  const [error, setError] = useState({ message: "", title: "" } as {
    message: string;
    title: string;
  });

  useEffect(() => {
    restoreValues();
  }, [prefeitura]);

  function handleSetNome(nNome: string) {
    setNome(nNome);
  }


  function validaForm() {
  

    return true;
  }

  async function post() {
    try {
      await checarTokenPrefeitura();
      setloading(true);
     
   
      setFormStatus("Visualizar");
    } catch (error) {
      console.log(error);
    } finally {
      setloading(false);
    }
  }

  function restoreValues() {
    setNome(prefeitura.NOME);
  
  }

  const [formStatus, setFormStatus] = useState(
    "Visualizar" as "Visualizar" | "Editar"
  );

  return (
    <Container>
      <MenuLateral titulo={prefeitura.NOME} />
      <Panel
        children={
          <>
            <Header type={"PERFIL"} />
            <Formulario>
              <HelperInput>
                <PerfilInput
                  execute={handleSetNome}
                  value={NOME}
                  title={"NOME"}
                  ativo={true}
                  disabled={formStatus == "Visualizar"}
                />
              </HelperInput>
            </Formulario>
            <HandleButton>
              <HandleEditarButton hidden={formStatus == "Editar"}>
              
                <HandleEditarButton hidden={formStatus == "Editar"}>
                  <DarkButton title={"EDITAR SENHA"} execute={() => { setEditarSenhaModal(true)}} />
                </HandleEditarButton>{" "}
              </HandleEditarButton>

              <HandleOperationButtons hidden={formStatus == "Visualizar"}>
                <DarkButton
                  title={"CANCELAR"}
                  execute={() => {
                    console.log(formStatus);
                    restoreValues();
                    setFormStatus("Visualizar");
                  }}
                />
              </HandleOperationButtons>
              <HandleOperationButtons hidden={formStatus == "Visualizar"}>
                <DarkButton
                  title={"SALVAR"}
                  execute={() => {
                    if (validaForm()) {
                      post();
                    }
                  }}
                />
              </HandleOperationButtons>
            </HandleButton>

            <Alert
              open={error.message.length > 0}
              onClose={() => setError({ message: "", title: "" })}
              message={error.message}
              title={error.title}
            />
            <EditarSenhaModal
              open={editarSenhaModal}
              onClose={() => setEditarSenhaModal(false)}
              prefeitura={prefeitura}
            />
            <ModalLoader loading={loading} />
          </>
        }
      />
    </Container>
  );
}

